"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ArraySlicer", {
    enumerable: true,
    get: function() {
        return ArraySlicer;
    }
});
/**
 * Introducing ArraySlicer, a utility class that allows us to iterate over an
 * array of things, each with a user-specified slice size.
 *
 * Usage:
 *
 * const slicer = new ArraySlicer([1,2,3,4,5], 2);
 *
 * for (const slice of slicer) {
 *   ... do something with slice
 * }
 *
 */ let ArraySlicer = class ArraySlicer {
    [Symbol.iterator]() {
        return {
            next: ()=>{
                var _this_logger;
                const first = this.currentIndex * this.sliceSize;
                const last = (this.currentIndex + 1) * this.sliceSize;
                (_this_logger = this.logger) == null ? void 0 : _this_logger.info(`ArraySlicer#nextSlice first: ${first}, last: ${last}, length: ${this.values.length}`);
                const slice = this.values.slice(first, last);
                this.currentIndex++;
                if (slice.length) {
                    return {
                        done: false,
                        value: slice
                    };
                }
                return {
                    done: true,
                    value: []
                };
            }
        };
    }
    /**
   * Constructs an instance of ArraySlicer
   *
   * @param values the array of values
   * @param sliceSize the slice size
   * @param logger an implementation of ILogger
   */ constructor(values, sliceSize = 100, logger){
        this.values = values;
        this.sliceSize = sliceSize;
        this.logger = logger;
        this.currentIndex = 0;
    }
};

//# sourceMappingURL=arrays.js.map